import DashboardSummaryCountsWidget from '../../../../components/DashboardSummaryCountsWidget/SummaryCountWidget'
import SvgIconProjects from '../../../../assets/inlineSvg/icon-projects.svg'
import SvgIconPolicies from '../../../../assets/inlineSvg/icon-policies.svg'
import SvgIconApiCalls from '../../../../assets/inlineSvg/icon-api-calls.svg'
import { RootState } from '../../../../rootReducer'
import {
  GENERIC_SUMMARY_COUNT,
  fetchProjectsSummaryWidgetData
} from '../../../summary/summarySlice'
import { GenericSummary } from '../../../../services/api/apiTypes'
import useUrlContext from '../../../../hooks/useUrlContext'
import { getShowLoader } from '../../../../reducers/requestReducer'
import { mockGenericSummaryCountWidgetData } from '../../renderer/utils/widgetMockdata'
import { getUniqueWidgetIndex, UNIQUE_WIDGET_INDEX } from '../../mainDashboardv2/constants'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import React, { useEffect } from 'react'

interface OwnProps {
  useMockData?: boolean
  widgetDatasourceId?: string
  widgetDashboardId?: string
}

interface StateProps {
  genericWidgetData: GenericSummary
  policiesCount?: number
  showLoader: boolean
}

interface DispatchProps {
  fetchProjectsSummaryWidgetData: (args: {
    datasourceId: string
    [UNIQUE_WIDGET_INDEX]?: string
  }) => void
}

type GenericSummaryCountComponentProps = OwnProps & StateProps & DispatchProps

const GenericSummaryCountsWidget = ({
  fetchProjectsSummaryWidgetData,
  genericWidgetData,
  policiesCount,
  showLoader,
  useMockData = false,
  widgetDatasourceId,
  widgetDashboardId
}: GenericSummaryCountComponentProps) => {
  const intl = useIntl()
  const context = useUrlContext()
  const datasourceId = widgetDatasourceId
    ? widgetDatasourceId
    : context.contextFilters.datasourceId || ''
  const { projectsCount, apiCount } = genericWidgetData
  const widgetIndex = getUniqueWidgetIndex(widgetDashboardId, widgetDatasourceId)

  useEffect(() => {
    if (useMockData) return
    if (datasourceId) {
      fetchProjectsSummaryWidgetData({ datasourceId, [UNIQUE_WIDGET_INDEX]: widgetIndex })
    }
  }, [fetchProjectsSummaryWidgetData, datasourceId, useMockData, widgetIndex])

  const widgetData = [
    {
      icon: <SvgIconProjects />,
      text: intl.formatMessage({ id: 'dashboard.generic.widget.text.projects' }),
      count: projectsCount || 0
    },
    {
      icon: <SvgIconApiCalls />,
      text: intl.formatMessage({ id: 'dashboard.dataSource.widget.text.apiCalls' }),
      count: apiCount
    },
    {
      icon: <SvgIconPolicies />,
      text: intl.formatMessage({ id: 'dashboard.dataSource.widget.text.policies' }),
      count: policiesCount || 0
    }
  ]

  return (
    <DashboardSummaryCountsWidget
      summaryItems={widgetData}
      showLoader={showLoader}
      useMockData={useMockData}
    />
  )
}

const mapStateToProps = (state: RootState, ownProps: OwnProps): StateProps => {
  const widgetIndex = getUniqueWidgetIndex(ownProps.widgetDashboardId, ownProps.widgetDatasourceId)
  return {
    genericWidgetData: ownProps?.useMockData
      ? mockGenericSummaryCountWidgetData.genericWidgetData
      : state.summary.widgetGenericSummaryData?.[widgetIndex] || {},
    policiesCount: ownProps?.useMockData
      ? mockGenericSummaryCountWidgetData.policiesCount
      : state.dashboardSummaryCounts.policiesCount?.[widgetIndex],
    showLoader: getShowLoader(GENERIC_SUMMARY_COUNT)
  }
}

const mapDispatchToProps: DispatchProps = {
  fetchProjectsSummaryWidgetData
}

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  mapStateToProps,
  mapDispatchToProps
)(GenericSummaryCountsWidget)
